
import './App.css';
import ImageG from './components/imageGereat/ImageG';

function App() {
  return (
    <div className="App">
      <ImageG />
    </div>
  );
}

export default App;
